// import React from "react";

import React, { useState, useEffect, useRef } from "react";
// import PhoneInput from 'react-phone-input-2';
import "react-phone-input-2/lib/style.css";

import { useLocation } from "react-router-dom";

import { useForm } from "react-hook-form";
import { FIELDS, STEPS } from "../utils/constants";
import { useFormStateContext } from "../utils/hooks";
import {
  InputField,
  InputError,
  InputContainer,
  InputLabel,
  Flex,
  Button,
} from "../utils/styles";
import style from "../utils/style.css";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import config from "../../commonconfig";

// const checkEmailExistence = "http://localhost:8004/api/check-email-existence";

const checkEmailExistence = "/check-email-existence";

export const ContactForm = () => {
  const { fields, setStep, updateFields } = useFormStateContext();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...fields.contact,
    },
  });

  // const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm();

  const [phone, setPhone] = useState("");

  const [emailExistMessage, checkEmailExist] = React.useState([]);

  const onSubmit = (data) => {
    // console.log(data)
    axios
      .post(`${config.site.apiUrl}${checkEmailExistence}`, data)
      .then((response) => {
        //       const payload = {
        //   // other form fields...
        //   click_id: clickId,
        // };

        if (response.data.success == false) {
          checkEmailExist(response.data.message);
          //toast.success('Email sent successfully!');
        } else {
          // updateFields(FIELDS.EMAIL, data.email, );
          // updateFields(FIELDS.CONTACT, data, );
          // updateFields(FIELDS.CONTACT, data.);
          updateFields(FIELDS.CONTACT, data);
          // setStep(STEPS.CONTACT);
          setStep(STEPS.MOBILE);
        }
      });
  };

  // const onSubmit = (data) => {
  //   console.log(data);
  //   updateFields(FIELDS.CONTACT, data);
  //   setStep(STEPS.MOBILE);
  // };

  const goBack = () => {
    setStep(STEPS.EMAIL);
  };

  const onError = (errors, event) => {
    console.log(errors);
    console.log(event);
  };

  const [clickId, setClickId] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const clickId = params.get("click_id") || "";

    setClickId(clickId);

    console.log(clickId);
  }, []);

  // const [clickId, setClickId] = useState('');
  // const formRef = useRef(null);

  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const extractedClickId = params.get('click_id') || '';
  //   setClickId(extractedClickId);
  //   console.log("land lele mera:", extractedClickId);

  //   // Automatically submit the form when the component mounts
  //   formRef.current && formRef.current.submit();
  // }, []);

  return (
    <div className="base-form">
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div className="button-back">
          <Button
            type="button"
            // children="Back"
            secondary
            style={{ margin: "0 10px" }}
            // onClick={goBack}
          >
            {/* <i class="fa fa-angle-left" aria-hidden="true"></i> 
           <i class="fa fa-arrow-left" aria-hidden="true"></i> */}
          </Button>
          <h4>Enter Your Details</h4>
          <div className="step-num">
            <h4>1/3</h4>
          </div>
        </div>
        <div className="f-container">
          <label className="name">Email</label>
          <InputContainer
            style={{ margin: "0px 0 20px 0" }}
            error={errors.email}
          >
            <Flex alignItems="center" justifyContent="space-between">
              <InputLabel children="" />
              {errors.email && <InputError children={errors.email.message} />}
              {!errors.email && emailExistMessage && (
                <InputError children={emailExistMessage} />
              )}
            </Flex>
            <InputField
              id="email"
              type="email"
              placeholder="abcd@gmail.com"
              {...register("email", {
                required: "Email is required",
              })}
            />

            {/* <label className='name'>Full Name</label>
            <Flex alignItems="center" justifyContent="space-between">
              
              <InputLabel htmlFor="firstName" children="" />
              {errors.firstName && (
                <InputError children={errors.firstName.message} />
              )}
            </Flex>
            <InputField
              id="firstName"
              placeholder='joe taylor'
              {...register('firstName', {
                required: 'Name required',
              })}
            /> */}
          </InputContainer>

          <label className="name">password</label>
          <InputContainer
            style={{ margin: "0px 0 20px 0" }}
            error={errors.password}
          >
            <Flex alignItems="center" justifyContent="space-between">
              <InputLabel htmlFor="" children="" />
              {errors.password && (
                <InputError children={errors.password.message} />
              )}
            </Flex>
            <InputField
              id="password"
              type="password"
              minLength={6}
              placeholder="Password"
              {...register("password", {
                required: "password is required",
                pattern: {
                  message: "Invalid password number",
                  // value: /^\d{8}$/,
                },
              })}
            />
          </InputContainer>

          {/* <label className='name'>Mobile Number</label>
        <InputContainer style={{ margin: '0px 0 20px 0' }} error={errors.phone}>
              <Flex alignItems="center" justifyContent="space-between">
                 <InputLabel htmlFor="" children="" />
                {errors.phone && <InputError children={errors.phone.message} />}
               </Flex>
            
               <PhoneInput
                   name="phone" 
                   id="phone"
                   country={'mt'}
                value={'phone'}
                   onChange={""}
                   placeholder="Enter Phone Number"
     

                  
                   // {...register('mobile', {
                   //     required: 'Mobile is required',
                   //     pattern: {
                  //       message: 'Invalid mobile number',
                  //       value: /^\d{10}$/,
                 //   })}
                 />

     
        </InputContainer> */}

          <label className="name">Mobile Number</label>
          <InputContainer
            style={{ margin: "0px 0 20px 0" }}
            error={errors.phone}
          >
            <Flex alignItems="center" justifyContent="space-between">
              <InputLabel children="" />
              {errors.phone && <InputError children={errors.phone.message} />}
            </Flex>
            <PhoneInput
              name="phone"
              id="phone"
              country={"mt"}
              placeholder="Enter Phone Number"
              value={watch("phone") || ""}
              onChange={(value) => setValue("phone", value)}
            />
          </InputContainer>

          <label className="name">Country</label>
          <InputContainer
            style={{ margin: "0px 0 20px 0", border: "solid 1px white" }}
            error={errors.country}
          >
            <Flex alignItems="center" justifyContent="space-between">
              <InputLabel htmlFor="" children="" />
              {errors.country && (
                <InputError children={errors.country.message} />
              )}
            </Flex>
            {/* <InputField
              id="countrycode"
              type="text" 
              placeholder='T400rx0'
              // maxLength={10}
              {...register('countrycode', {
                required: 'countrycode is required',
                pattern: {
                  message: 'Select the countrycode',
                  // value: /^\d{8}$/,
                },
              })}
            /> */}

            <select
              id="country"
              name="country"
              class="form-control"
              {...register("country", {})}
            >
              {/* <select  id="countrycode " name="country" class="form-control" > */}
              <option value="Malta" className="malta-default">
                Malta
              </option>
              <option value="Afghanistan">Afghanistan</option>
              <option value="Åland Islands">Åland Islands</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="American Samoa">American Samoa</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Anguilla">Anguilla</option>
              <option value="Antarctica">Antarctica</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Aruba">Aruba</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bermuda">Bermuda</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegovina">
                Bosnia and Herzegovina
              </option>
              <option value="Botswana">Botswana</option>
              <option value="Bouvet Island">Bouvet Island</option>
              <option value="Brazil">Brazil</option>
              <option value="British Indian Ocean Territory">
                British Indian Ocean Territory
              </option>
              <option value="Brunei Darussalam">Brunei Darussalam</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Cape Verde">Cape Verde</option>
              <option value="Cayman Islands">Cayman Islands</option>
              <option value="Central African Republic">
                Central African Republic
              </option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Christmas Island">Christmas Island</option>
              <option value="Cocos (Keeling) Islands">
                Cocos (Keeling) Islands
              </option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo">Congo</option>
              <option value="Congo, The Democratic Republic of The">
                Congo, The Democratic Republic of The
              </option>
              <option value="Cook Islands">Cook Islands</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Cote D'ivoire">Cote D'ivoire</option>
              <option value="Croatia">Croatia</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Falkland Islands (Malvinas)">
                Falkland Islands (Malvinas)
              </option>
              <option value="Faroe Islands">Faroe Islands</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="French Guiana">French Guiana</option>
              <option value="French Polynesia">French Polynesia</option>
              <option value="French Southern Territories">
                French Southern Territories
              </option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Gibraltar">Gibraltar</option>
              <option value="Greece">Greece</option>
              <option value="Greenland">Greenland</option>
              <option value="Grenada">Grenada</option>
              <option value="Guadeloupe">Guadeloupe</option>
              <option value="Guam">Guam</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guernsey">Guernsey</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-bissau">Guinea-bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Heard Island and Mcdonald Islands">
                Heard Island and Mcdonald Islands
              </option>
              <option value="Holy See (Vatican City State)">
                Holy See (Vatican City State)
              </option>
              <option value="Honduras">Honduras</option>
              <option value="Hong Kong">Hong Kong</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran, Islamic Republic of">
                Iran, Islamic Republic of
              </option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Isle of Man">Isle of Man</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jersey">Jersey</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Korea, Democratic People's Republic of">
                Korea, Democratic People's Republic of
              </option>
              <option value="Korea, Republic of">Korea, Republic of</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Lao People's Democratic Republic">
                Lao People's Democratic Republic
              </option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon">Lebanon</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libyan Arab Jamahiriya">
                Libyan Arab Jamahiriya
              </option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Macao">Macao</option>
              <option value="Macedonia, The Former Yugoslav Republic of">
                Macedonia, The Former Yugoslav Republic of
              </option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Martinique">Martinique</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mayotte">Mayotte</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia, Federated States of">
                Micronesia, Federated States of
              </option>
              <option value="Moldova, Republic of">Moldova, Republic of</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montenegro">Montenegro</option>
              <option value="Montserrat">Montserrat</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar">Myanmar</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="Netherlands Antilles">Netherlands Antilles</option>
              <option value="New Caledonia">New Caledonia</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="Niue">Niue</option>
              <option value="Norfolk Island">Norfolk Island</option>
              <option value="Northern Mariana Islands">
                Northern Mariana Islands
              </option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Palestinian Territory, Occupied">
                Palestinian Territory, Occupied
              </option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Pitcairn">Pitcairn</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Puerto Rico">Puerto Rico</option>
              <option value="Qatar">Qatar</option>
              <option value="Reunion">Reunion</option>
              <option value="Romania">Romania</option>
              <option value="Russian Federation">Russian Federation</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Helena">Saint Helena</option>
              <option value="Saint Kitts and Nevis">
                Saint Kitts and Nevis
              </option>
              <option value="Saint Lucia">Saint Lucia</option>
              <option value="Saint Pierre and Miquelon">
                Saint Pierre and Miquelon
              </option>
              <option value="Saint Vincent and The Grenadines">
                Saint Vincent and The Grenadines
              </option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">
                Sao Tome and Principe
              </option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Serbia">Serbia</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra Leone">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Georgia and The South Sandwich Islands">
                South Georgia and The South Sandwich Islands
              </option>
              <option value="Spain">Spain</option>
              <option value="Sri Lanka">Sri Lanka</option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Svalbard and Jan Mayen">
                Svalbard and Jan Mayen
              </option>
              <option value="Swaziland">Swaziland</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syrian Arab Republic">Syrian Arab Republic</option>
              <option value="Taiwan">Taiwan</option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania, United Republic of">
                Tanzania, United Republic of
              </option>
              <option value="Thailand">Thailand</option>
              <option value="Timor-leste">Timor-leste</option>
              <option value="Togo">Togo</option>
              <option value="Tokelau">Tokelau</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Turks and Caicos Islands">
                Turks and Caicos Islands
              </option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="United States Minor Outlying Islands">
                United States Minor Outlying Islands
              </option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Viet Nam">Viet Nam</option>
              <option value="Virgin Islands, British">
                Virgin Islands, British
              </option>
              <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
              <option value="Wallis and Futuna">Wallis and Futuna</option>
              <option value="Western Sahara">Western Sahara</option>
              <option value="Yemen">Yemen</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </select>
          </InputContainer>

          {/* <label className='name'>click_id</label> */}
          {/* <InputContainer> */}
          {/* <Flex alignItems="center" justifyContent="space-between">
              <InputLabel htmlFor="" children="" />
              {errors.click_id && <InputError children={errors.click_id.message} />}
            </Flex> */}
          <InputField
            style={{
              backgroundColor: "#00ffff00",
              border: "#00ffff00",
              color: "#00ffff00",
              outline: "none",
              fontSize: "0px",
              margin: "0",
              padding: "0",
              height: "0",
              width: "0",
            }}
            id="click_id"
            type="text"
            placeholder="click_id"
            defaultValue={clickId}
            value={clickId}
            autoFocus
            selected
            {...register("click_id", {})}
          />

          {/* </InputContainer> */}

          {/* <label className='name'>Full Name</label>
          <InputContainer style={{ margin: '10px 0' }} error={errors.firstName}>
            <Flex alignItems="center" justifyContent="space-between">
              
              <InputLabel htmlFor="firstName" children="" />
              {errors.firstName && (
                <InputError children={errors.firstName.message} />
              )}
            </Flex>
            <InputField
              id="firstName"
              placeholder='joe taylor'
              {...register('firstName', {
                required: 'Name required',
              })}
            />
          </InputContainer>
          <InputContainer style={{ margin: '10px 0' }} error={errors.lastName}>
            <Flex alignItems="center" justifyContent="space-between">
              <InputLabel htmlFor="lastName" children="Last Name" />
              {errors.lastName && (
                <InputError children={errors.lastName.message} />
              )}
            </Flex>
            <InputField
              id="lastName"
              {...register('lastName', {
                // required: 'Last name required',
              })}
            />
          </InputContainer> */}

          <div className="for-button-manage">
            <InputContainer error={errors.age}>
              <Flex alignItems="center" justifyContent="space-between">
                <InputLabel htmlFor="" children="" />
                {errors.age && <InputError children={errors.age.message} />}
              </Flex>
              <InputField
                id="age"
                name="age"
                value="age"
                type="checkbox"
                // maxLength={10}
                {...register("age", {
                  required: "Age 18+ is required",
                  pattern: {
                    message: "Select the age",
                    // value: /^\d{8}$/,
                  },
                })}
              />
              {/* <label className="terms5" for="privacyconsent">Terms and conditions <a href='https://www.safebettingsites.com/terms-conditions/' target="_blank">learn more</a></label> */}
              <label className="terms5" for="age">
                “I am 18 years of age or older and agree to the{" "}
                <a target="_blanck" href="Terms-and-Conditions">
                  Terms & Conditions
                </a>
                , the{" "}
                <a
                  target="_blanck"
                  href="Privacy-&-Management-Of-Personal-Data"
                >
                  Privacy Policy
                </a>{" "}
                and the{" "}
                <a target="_blanck" href="sport-rules">
                  Sport Rules
                </a>
                "
              </label>
            </InputContainer>

            <div className="button-next">
              <Button children="Next">
                Next Step<span className="enter"></span>{" "}
                <i class="fa-solid fa-arrow-right"></i>{" "}
              </Button>
            </div>
            {/* <p class="hidden-xs">&nbsp;</p> */}
            <div class="terms5">
              <p className="text-center">
                {" "}
                <a href="/login">Already have an account? </a>
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

// import React from "react";
// import { useForm } from 'react-hook-form';
// import { FIELDS, STEPS } from '../utils/constants';
// import { useFormStateContext } from '../utils/hooks';
// import {
//   InputField,
//   InputError,
//   InputContainer,
//   InputLabel,
//   Flex,
//   Button,
// } from '../utils/styles';
// import style from '../utils/style.css'

// export const ContactForm = () => {
//   const { fields, setStep, updateFields } = useFormStateContext();
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {
//       ...fields.contact,
//     },
//   });

//   const onSubmit = (data) => {
//     console.log(data);
//     updateFields(FIELDS.CONTACT, data);
//     setStep(STEPS.MOBILE);
//   };

//   const goBack = () => {
//     setStep(STEPS.EMAIL);
//   };

//   const onError = (errors, event) => {
//     console.log(errors);
//     console.log(event);
//   };

//   return (
//     <div className="base-form">
//       <form onSubmit={handleSubmit(onSubmit, onError)}>
//       <div className='button-back'>
//           <Button
//             type="button"
//             children="Back"
//             secondary
//             style={{ margin: '0 10px' }}
//             onClick={goBack}
//           > <i class="fa fa-angle-left" aria-hidden="true"></i></Button>
//            <h4>Enter name</h4>
//         </div>
//         <div className="f-container">

//           <label className='name'>Full Name</label>
//           <InputContainer style={{ margin: '10px 0' }} error={errors.firstName}>
//             <Flex alignItems="center" justifyContent="space-between">

//               <InputLabel htmlFor="firstName" children="" />
//               {errors.firstName && (
//                 <InputError children={errors.firstName.message} />
//               )}
//             </Flex>
//             <InputField
//               id="firstName"
//               placeholder='joe taylor'
//               {...register('firstName', {
//                 required: 'Name required',
//               })}
//             />
//           </InputContainer>
//           {/* <InputContainer style={{ margin: '10px 0' }} error={errors.lastName}>
//             <Flex alignItems="center" justifyContent="space-between">
//               <InputLabel htmlFor="lastName" children="Last Name" />
//               {errors.lastName && (
//                 <InputError children={errors.lastName.message} />
//               )}
//             </Flex>
//             <InputField
//               id="lastName"
//               {...register('lastName', {
//                 // required: 'Last name required',
//               })}
//             />
//           </InputContainer> */}
//           <div className='button-next'>
//           <Button children="Next" >Press <span className="enter">Enter</span>  <i class="fa fa-angle-right" aria-hidden="true"></i> </Button>
//           </div>
//           <p class="hidden-xs">&nbsp;</p>
//           <div class="terms5">
//             <p className='text-center'> Already have an account with us? <a href="/login">Please Sign In</a>
//             </p>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// };
